import type { SVGProps } from 'react'
const SvgSyBoxFill = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path
			fillOpacity={0.24}
			d="M4 9.3c0-.141 0-.212.044-.256S4.159 9 4.3 9h15.4c.141 0 .212 0 .256.044S20 9.159 20 9.3V16c0 1.886 0 2.828-.586 3.414S17.886 20 16 20H8c-1.886 0-2.828 0-3.414-.586S4 17.886 4 16zM4.724 8c-.308 0-.462 0-.5-.093-.039-.092.07-.201.288-.42l1.316-1.315c.578-.578.868-.868 1.235-1.02S7.84 5 8.657 5h6.686c.818 0 1.226 0 1.594.152s.657.442 1.235 1.02l1.316 1.316c.218.218.327.327.289.42S19.584 8 19.276 8z"
		/>
		<path d="M9 9.15A.15.15 0 0 1 9.15 9h5.7a.15.15 0 0 1 .15.15v4.916a.5.5 0 0 1-.777.416l-1.668-1.112a1 1 0 0 0-1.11 0l-1.668 1.112A.5.5 0 0 1 9 14.066z" />
	</svg>
)
export default SvgSyBoxFill
